import {useMount} from '@s-ui/react-hooks'
import Layout from '@adv-mt/mt-layout-basic'

import LinkFactory from '../../../components/LinkFactory/index.js'

export const Skeleton = () => {
  useMount(() => {
    window.scrollTo(0, 0)
  })

  return (
    <Layout.Basic linkFactory={LinkFactory}>
      <div className={`mt-NewsDetail-skeleton`} />
    </Layout.Basic>
  )
}
